var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tags-input',{attrs:{"tags":_vm.jobs,"is-duplicate":_vm.isDuplicate,"autocomplete-items":_vm.filteredItems,"placeholder":" "},on:{"tags-changed":newTags => _vm.jobs = newTags},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }